import { combineEpics } from 'redux-observable';
import I18n from 'I18n';
import { of, empty } from '../common/rxjs/observable';
import { map, catchError } from '../common/rxjs/operators';
import { createAction } from '../common/actions';
import Actions from './actions';
import API from './api';
import { actionMergeMap } from '../common/epics';
import { tracker } from '../lib/tracker';
import { captureMessage } from '../common/sentry';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
const catchErrorToFailAction = (action, key) => {
  return catchError(error =>
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'FAIL' does not exist on type '{}'.
  of(createAction(Actions.FAIL, {
    key,
    error,
    action
  })));
};
export default combineEpics(actionMergeMap(Actions.ADD_SUBMIT, action => API.add(action.payload).pipe(map(() => createAction(Actions.ADD_SUCCESS, action.payload)), catchErrorToFailAction(action, 'emails.failures.titles.addFail'))), actionMergeMap(Actions.DELETE_SUBMIT, action => API.delete(action.payload).pipe(map(() => createAction(Actions.DELETE_SUCCESS, action.payload)), catchErrorToFailAction(action, 'emails.failures.titles.deleteFail'))), actionMergeMap(Actions.RESEND_VERIFY_SUBMIT, action => API.resendVerification(action.payload).pipe(map(() => createAction(Actions.RESEND_VERIFY_SUCCESS, action.payload)), catchErrorToFailAction(action, 'emails.failures.titles.resendVerifyFail'))), actionMergeMap(Actions.ADD_SUCCESS, action => {
  FloatingAlertStore.addAlert({
    titleText: I18n.text('emails.added.title', {
      email: action.payload
    }),
    timeout: 5000,
    type: 'success'
  });
  tracker.track('usage', {
    action: 'addEmailAlias'
  });
  return empty();
}), actionMergeMap(Actions.DELETE_SUCCESS, action => {
  FloatingAlertStore.addAlert({
    titleText: I18n.text('emails.deleted.title', {
      email: action.payload
    }),
    timeout: 5000,
    type: 'success'
  });
  tracker.track('usage', {
    action: 'deleteEmailAlias'
  });
  return empty();
}), actionMergeMap(Actions.RESEND_VERIFY_SUCCESS, action => {
  FloatingAlertStore.addAlert({
    titleText: I18n.text('emails.resentVerify.title', {
      email: action.payload
    }),
    message: I18n.text('emails.resentVerify.message'),
    timeout: 5000,
    type: 'success'
  });
  return empty();
}), actionMergeMap(Actions.FAIL, action => {
  FloatingAlertStore.addAlert({
    titleText: I18n.text(action.payload.key, action.payload),
    message: I18n.text('emails.failures.message'),
    type: 'danger'
  });
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
  captureMessage('email alias failure', action.payload);
  return empty();
}));